import React from 'react'
import FacebookImg from '../../assets/images/png/facebook.png'
import './style.css'

export default function FacebookButton({ width, height }) {
    return (
       
            <a 
                href="https://m.facebook.com/bangkokgift.net/"
                className="facebook-button"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: width ?? "100%", height: height ?? "50px" }}
            >
                <img
                    src={FacebookImg}
                    alt="Facebook"
                    className="facebook-button-img"
                />
                <span>Messenger</span>
            </a>
        );

}
